import { Turbo } from '@hotwired/turbo-rails';
import '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

window.bootstrap = bootstrap;

import './controllers';
import './chart_defaults';
import './notifications';
import './google_analytics';
import './bootstrap_validation';

Turbo.session.drive = false;
